module.exports = __webpack_public_path__ + "img/match-vs-2.26e31119.png";